import { Screen } from '@ui';
import { PropsWithChildren, ReactNode } from 'react';
import * as css from './StudentSettings.css';

export const StudentSettingsRoot = ({ children, buttons }: PropsWithChildren<Record<'buttons', ReactNode>>) => (
    <Screen.Root
        title="Student settings"
        header={{
            static: {
                end: buttons,
            },
        }}
    >
        <Screen.Column span="20/20">
            <div className={css.content}>{children}</div>
        </Screen.Column>
    </Screen.Root>
);
